export {
  fetchLegalDocuments,
  type LegalDocument,
  type LegalDocumentsResponse,
} from './legalDocuments';
